function mark(name, detail = null) {
  if (
    typeof window === 'undefined'
    || typeof performance === 'undefined'
    || typeof performance.mark !== 'function'
  ) {
    return;
  }
  const payload = detail ? { detail } : undefined;
  try {
    performance.mark(name, payload);
  } catch (_) {
    try {
      performance.mark(name);
    } catch (__ ) {
      // noop
    }
  }
}

function measure(name, startMark, endMark, detail = null) {
  if (
    typeof window === 'undefined'
    || typeof performance === 'undefined'
    || typeof performance.measure !== 'function'
    || typeof performance.getEntriesByName !== 'function'
  ) {
    return null;
  }
  try {
    performance.measure(name, {
      start: startMark,
      end: endMark,
      detail,
    });
  } catch (_) {
    try {
      performance.measure(name, startMark, endMark);
    } catch (__ ) {
      return null;
    }
  }

  const entries = performance.getEntriesByName(name);
  const entry = entries[entries.length - 1] || null;
  if (!entry) return null;

  window.__APBIO_STUDY_RUNTIME_METRICS = window.__APBIO_STUDY_RUNTIME_METRICS || [];
  window.__APBIO_STUDY_RUNTIME_METRICS.push({
    name,
    duration: entry.duration,
    startTime: entry.startTime,
    detail,
  });

  return entry;
}

export function markStudyTabNavigationStart(tabId) {
  mark(`study-tab:${tabId}:navigation-start`, { tabId });
}

export function markStudyTabRouteCommit(tabId) {
  mark(`study-tab:${tabId}:route-commit`, { tabId });
  measure(
    `study-tab:${tabId}:route-latency`,
    `study-tab:${tabId}:navigation-start`,
    `study-tab:${tabId}:route-commit`,
    { tabId }
  );
}

export function markStudyTabShellVisible(tabId) {
  mark(`study-tab:${tabId}:shell-visible`, { tabId });
  measure(
    `study-tab:${tabId}:shell-visible-latency`,
    `study-tab:${tabId}:navigation-start`,
    `study-tab:${tabId}:shell-visible`,
    { tabId }
  );
}

export function markStudyTabDataReady(tabId) {
  mark(`study-tab:${tabId}:data-ready`, { tabId });
  measure(
    `study-tab:${tabId}:data-ready-latency`,
    `study-tab:${tabId}:navigation-start`,
    `study-tab:${tabId}:data-ready`,
    { tabId }
  );
}

export function markStudyTabInteractiveReady(tabId) {
  mark(`study-tab:${tabId}:interactive-ready`, { tabId });
  measure(
    `study-tab:${tabId}:interactive-ready-latency`,
    `study-tab:${tabId}:navigation-start`,
    `study-tab:${tabId}:interactive-ready`,
    { tabId }
  );
}

export function markStudyTabReady(tabId) {
  markStudyTabInteractiveReady(tabId);
}
